/* eslint sort-keys: 1 */

import { TMarketplace } from '@com/core/common/types/config';
import { IMG_BASE, baseConfig } from '@com/core/common/baseConfig';
import { TMarketplaceConfig } from '../common/types/config';

export const IS_DOCKER_NON_DEV = process.env.DOCKER === 'yes' && process.env.ENV !== 'dev';
// eslint-disable-next-line no-underscore-dangle
export const MARKETPLACE = process.env._MARKETPLACE as TMarketplace;
// eslint-disable-next-line no-underscore-dangle
export const DOMAIN = process.env.ENV !== 'prod' ? `${MARKETPLACE}stg` : MARKETPLACE;
export const IS_BROWSER = typeof window !== 'undefined';
export const SVC_ENDPOINT = IS_BROWSER ? '/_svc' : `https://api-app-daily.${DOMAIN}.com/_svc`;

const marketplaceConfig: TMarketplaceConfig = {
    ...baseConfig,
    commonHeaders: {
        ...baseConfig.commonHeaders,
        'x-mp': 'daily',
    },
    endpoints: {
        ...baseConfig.endpoints,
        catalog:
            IS_DOCKER_NON_DEV && !IS_BROWSER
                ? 'http://catalog-daily-noratelimit/api'
                : SVC_ENDPOINT.replace('/_svc', '/_svc/catalog/api'),
        services: SVC_ENDPOINT,
    },
    regions: {
        ...baseConfig.regions,
        ae: {
            ...baseConfig.regions.ae,
            codLimit: 5000,
            consumerRights: '/consumer-rights',
            enabled: true,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'amex'],
            supportEmail: 'care@noon.com',
            supportPhone: 'xxxx',
        },
        eg: {
            ...baseConfig.regions.eg,
            codLimit: 5000,
            enabled: false,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'amex'],
            supportEmail: 'care@noon.com',
            supportPhone: 'xxxxx',
        },
        sa: {
            ...baseConfig.regions.sa,
            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'amex'],
            supportEmail: 'care@noon.com',
            supportPhone: 'xxxx',
        },
    },
    urls: {
        ...baseConfig.urls,
        appStore: 'https://itunes.apple.com/app/noon-%D9%86%D9%88%D9%86/id1269038866?ls=1&mt=8',
        facebook: 'https://facebook.com/noon/',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.noon.buyerapp',
        instagram: 'https://www.instagram.com/noon/',
        linkedin: 'https://www.linkedin.com/company/18045372/',
        supportInfo: {
            careers: 'https://www.jobsatnoon.com/',
            partners: `https://login.noon.partners/en/register`,
            privacyPolicy: '/privacy-policy',
            termsOfSale: '/terms-of-sale',
            termsOfUse: '/terms-of-use',
            warrantyPolicy: '/warranty-policy',
        },
        twitter: 'https://twitter.com/noon/',
    },

    // eslint-disable-next-line sort-keys
    assets: {
        ...baseConfig.assets,
        icons: {
            ...baseConfig.assets.icons,

            address: '',
            arrowDiagonal: '',
            backArrow: '',
            caretDown: '',
            cart: '',
            cartBlack: '',
            cartBrand: '',
            cartWhite: '',
            check: ``,
            checkboxChecked: '',
            checkboxUnchecked: '',
            chevronDown: ``,
            chevronUp: ``,
            claims: '',
            closeXBlack: ``,
            closeXWhite: ``,
            collectionPointsToggle: '',
            coupon: '',
            credits: '',
            edit: '',

            favicon: `${IMG_BASE}/daily/icons/favicon.ico`,

            gift: '',
            globe: '',
            hamburger: '',
            help: '',
            home: '',
            info: ``,
            magnifyingGlass: '',
            minus: '',
            nextDayDelivery: '',
            noonPay: '',
            orders: '',
            payments: '',
            plus: '',
            preferences: '',
            prepaidOnly: '',
            profile: '',
            returns: '',
            returnsUsp: '',
            search: ',',
            share: '',
            shipment: '',
            shipmentMethod: {
                dd: '',
                fallback: '',
                sc: '',
                sdd: '',
            },
            shop: '',
            signOut: '',
            trash: '',
            user: '',
            wishList: '',
            wishListAdded: ``,
            wishListBlack: '',
        },
        images: {
            ...baseConfig.assets.images,
            addressCollectionIndicator: '',
            addressLatLngIndicator: '',
            addressesEmptySlate: '',
            bankTransferEmpty: '',
            cartEmpty: '',
            chevronRight: '',
            chevronRightWhite: '',
            claimAmountExceeded: '',
            claimsEmptySlate: '',
            claimsSuccessSlate: '',
            claimsTypeChecked: '',
            claimsTypeDamage: '',
            claimsTypeProtection: '',
            claimsTypeUnchecked: '',
            defaultMap: '',
            defaultProductPlaceholder: '',
            error404: '',
            fulfilmentExpressAr: '',
            fulfilmentExpressEn: '',
            fulfilmentPreOrderAr: '',
            fulfilmentPreOrderEn: '',
            fulfilmentMarketplaceEn: '',
            fulfilmentMarketplaceAr: '',
            logoBG: '',
            loyalty: {
                bulletCheck: '',
                bulletStar: '',
                tick: '',
                vip: '',
                vipAR: '',
                vipEN: '',
            },
            mapCollectionPointLocker: '',
            mapCollectionPointPickup: '',
            mapCollectionPointToggle: '',
            mapLandmarkPin: '',
            mapLocateMeAr: '',
            mapLocateMeEn: '',
            openGraphImage: '',
            paymentEmptySlate: '',
            returnSuccess: '',
            returnablesEmptyState: '',
            returnsEmptyState: '',
            secure: '',
            toggleActive: '',
            toggleInactive: '',
            transferRequestSuccess: '',
        },
    },
    headerSupportBar: false,

    // eslint-disable-next-line sort-keys
    gtm: {
        ...baseConfig.gtm,
        gaID: 'UA-84507530-22',
        gtmID: 'GTM-5VGV6M2',
        optimizeID: 'xxx',
    },

    // eslint-disable-next-line sort-keys
    enabledFeatures: {
        etracking: true,
        loyalty: false,
        fingerprinting: true,
    },

    etracking: {
        url: 'https://etracker.noon.com/track',
        id: 'daily',
    },
};

export default marketplaceConfig;
